import { ScatterPickEvent } from "../../../../controller/event/GameEvent";
import { AbstractCameraRig } from "./AbstractCameraRig";
/**
 * Controls the zoom-in camera transition for the scatter pick intro.
 */
export class ScatterPickIntroCameraRig extends AbstractCameraRig {
    create() {
        super.create();
        this.progress = 0;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(ScatterPickEvent.TRANSITION_IN, this.playIntro);
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.recentreFocus();
        this.applyZoom();
    }
    async playIntro() {
        this.progress = 0;
        this.applyZoom();
        this.zoomTween = gsap.to(this, {
            progress: 1,
            duration: 2,
            ease: "power2.inOut",
            onUpdate: () => this.applyZoom(),
        });
        await this.zoomTween;
    }
    applyZoom() {
        const zoomScale = 1 + (this.uiProperties.scatterPickZoomStart - 1) * this.progress;
        this.scale.set(zoomScale);
    }
}
//# sourceMappingURL=ScatterPickIntroCameraRig.js.map